// import React, { useState } from 'react';
// import Box from '@mui/material/Box';
// import Typography from '@mui/material/Typography';
// import Modal from '@mui/material/Modal';
// import Grid from '@mui/material/Grid';
// import axios from 'axios';
// import Loader from '../common/Loader';
// import ReactQuill from 'react-quill';
// import 'react-quill/dist/quill.snow.css';
// import toast from 'react-hot-toast';

// const style = {
//   position: 'absolute',
//   top: '50%',
//   left: '50%',
//   transform: 'translate(-50%, -50%)',
//   width: '90%',
//   maxWidth: 600,
//   height: 'auto',
//   bgcolor: 'background.paper',
//   border: 'none',
//   boxShadow: 24,
//   borderRadius: '16px',
//   p: { xs: 2, md: 2 },
// };

// const AddBlogModal = ({ open, handleClose, allBlogs }) => {
//   const [formData, setFormData] = useState({
//     title: '',
//     author: '',
//     dateOfPublish: '',
//     description: '',
//   });
//   const [imageFile, setImageFile] = useState(null);
//   const [imagePreview, setImagePreview] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);

//   const clearState = () => {
//     setFormData({ title: '', author: '', dateOfPublish: '', description: '' });
//     setImageFile(null);
//     setImagePreview(null);
//   };

//   const handleQuillChange = (value) => {
//     setFormData((prev) => ({ ...prev, description: value }));
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setImageFile(file);
//       setImagePreview(URL.createObjectURL(file));
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!imageFile) return alert('Please select an image file.');

//     setIsLoading(true);

//     try {
//       const uploadData = new FormData();
//       uploadData.append('file', imageFile);
//       uploadData.append('upload_preset', process.env.REACT_APP_UPLOAD_PRESET);

//       const uploadRes = await axios.post(
//         `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/image/upload`,
//         uploadData
//       );

//       const imageUrl = uploadRes.data.secure_url;

//       const payload = {
//         title: formData.title,
//         author: formData.author,
//         dateOfPublish: formData.dateOfPublish || new Date().toISOString(),
//         image: [imageUrl],
//         description: formData.description,
//       };

//       await axios.post(`${process.env.REACT_APP_API_URL}/blog-post/create-blog-post`, payload, {
//         headers: { 'Content-Type': 'application/json' },
//       });

//       clearState();
//       handleClose();
//       allBlogs();
//       toast.success ('Blog Added Successfull')
//     } catch (error) {
//       // console.error('Error adding blog:', error);
//       toast.error('Failed to add blog.');
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <Modal open={open} onClose={handleClose}>
//       <Box sx={style}>
//         {/* Centered Loading Overlay */}
//         {isLoading && (
//           <div className="absolute inset-0 z-50 flex flex-col items-center justify-center bg-white bg-opacity-80 rounded-2xl">
//             <Loader />
//             <p className="mt-3 text-sm font-medium text-gray-500 tracking-wide">Uploading & Saving...</p>
//           </div>
//         )}

//         <Typography variant="h6" className="text-center mb-4 relative">
//           Add New Blog
//           <div
//             onClick={handleClose}
//             className="text-xl absolute top-0 right-2 cursor-pointer text-[#FF8607]"
//           >
//             ✕
//           </div>
//         </Typography>

//         <form className="h-[22rem] overflow-y-scroll" onSubmit={handleSubmit}>
//           <Grid container spacing={2}>
//             <Grid item xs={12}>
//               <input
//                 type="text"
//                 name="title"
//                 placeholder="Title"
//                 value={formData.title}
//                 onChange={handleChange}
//                 className="w-full border p-2 rounded"
//                 required
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <input
//                 type="text"
//                 name="author"
//                 placeholder="Author"
//                 value={formData.author}
//                 onChange={handleChange}
//                 className="w-full border p-2 rounded"
//                 required
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <input
//                 type="date"
//                 name="dateOfPublish"
//                 value={formData.dateOfPublish}
//                 onChange={handleChange}
//                 className="w-full border p-2 rounded"
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <Typography variant="subtitle1" className="mb-1">Description</Typography>
//               <ReactQuill
//                 theme="snow"
//                 value={formData.description}
//                 onChange={handleQuillChange}
//                 modules={{
//                   toolbar: [
//                     [{ header: [1, 2, 3, false] }],
//                     ['bold', 'italic', 'underline', 'strike'],
//                     [{ color: [] }, { background: [] }],
//                     [{ align: [] }],
//                     ['blockquote', 'code-block'],
//                     ['link', 'image'],
//                     ['clean'],
//                   ],
//                 }}
//                 formats={[
//                   'header', 'bold', 'italic', 'underline', 'strike',
//                   'color', 'background', 'align', 'blockquote',
//                   'code-block', 'link', 'image',
//                 ]}
//                 className="bg-white"
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <div className="mb-1 text-sm font-medium text-gray-700">
//                 Choose a Blog Image (600×500 size)
//               </div>
//               <input
//                 type="file"
//                 accept="image/*"
//                 onChange={handleImageChange}
//                 required
//                 className="mt-1"
//               />
//               {/* Image Preview */}
//               {imagePreview && (
//                 <div className="mt-3">
//                   <p className="text-xs text-gray-500 mb-1">Preview:</p>
//                   <img
//                     src={imagePreview}
//                     alt="Preview"
//                     className="w-full max-h-48 object-cover rounded-lg border border-gray-200 shadow-sm"
//                   />
//                 </div>
//               )}
//             </Grid>

//             <Grid item xs={12}>
//               <button
//                 type="submit"
//                 className="w-full bg-gradient-to-r from-[#FF3131] to-[#ff9301] text-white py-2 rounded-md"
//                 disabled={isLoading}
//               >
//                 Add Blog
//               </button>
//             </Grid>
//           </Grid>
//         </form>
//       </Box>
//     </Modal>
//   );
// };

// export default AddBlogModal;


import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Grid from '@mui/material/Grid';
import axios from 'axios';
import Loader from '../common/Loader';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import toast from 'react-hot-toast';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: 600,
  height: 'auto',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
  borderRadius: '16px',
  p: { xs: 2, md: 2 },
};

const AddBlogModal = ({ open, handleClose, allBlogs }) => {
  const [formData, setFormData] = useState({
    title: '',
    author: '',
    dateOfPublish: '',
    description: '',
    metaTitle: '',
    metaDescription: '',
    keywords: '',
    canonical: '',
  });
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const clearState = () => {
    setFormData({ 
      title: '', 
      author: '', 
      dateOfPublish: '', 
      description: '',
      metaTitle: '',
      metaDescription: '',
      keywords: '',
      canonical: '',
    });
    setImageFile(null);
    setImagePreview(null);
  };

  const handleQuillChange = (value) => {
    setFormData((prev) => ({ ...prev, description: value }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Auto-generate meta title from title
  const handleTitleChange = (e) => {
    const title = e.target.value;
    setFormData((prev) => ({ 
      ...prev, 
      title,
      metaTitle: title ? `${title} | BBSR Services` : ''
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!imageFile) return alert('Please select an image file.');

    setIsLoading(true);

    try {
      const uploadData = new FormData();
      uploadData.append('file', imageFile);
      uploadData.append('upload_preset', process.env.REACT_APP_UPLOAD_PRESET);

      const uploadRes = await axios.post(
        `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/image/upload`,
        uploadData
      );

      const imageUrl = uploadRes.data.secure_url;

      const payload = {
        title: formData.title,
        author: formData.author,
        dateOfPublish: formData.dateOfPublish || new Date().toISOString(),
        image: [imageUrl],
        description: formData.description,
        metaTitle: formData.metaTitle || `${formData.title} | BBSR Services`,
        metaDescription: formData.metaDescription,
        keywords: formData.keywords,
        canonical: formData.canonical,
      };

      await axios.post(`${process.env.REACT_APP_API_URL}/blog-post/create-blog-post`, payload, {
        headers: { 'Content-Type': 'application/json' },
      });

      clearState();
      handleClose();
      allBlogs();
      toast.success('Blog Added Successfully');
    } catch (error) {
      toast.error('Failed to add blog.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        {isLoading && (
          <div className="absolute inset-0 z-50 flex flex-col items-center justify-center bg-white bg-opacity-80 rounded-2xl">
            <Loader />
            <p className="mt-3 text-sm font-medium text-gray-500 tracking-wide">Uploading & Saving...</p>
          </div>
        )}

        <Typography variant="h6" className="text-center mb-4 relative">
          Add New Blog
          <div
            onClick={handleClose}
            className="text-xl absolute top-0 right-2 cursor-pointer text-[#FF8607]"
          >
            ✕
          </div>
        </Typography>

        <form className="h-[32rem] overflow-y-scroll px-2" onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <label className="text-sm font-medium">Blog Title</label>
              <input
                type="text"
                name="title"
                placeholder="Enter blog title"
                value={formData.title}
                onChange={handleTitleChange}
                className="w-full border p-2 rounded mt-1"
                required
              />
            </Grid>

            <Grid item xs={12}>
              <label className="text-sm font-medium">Author</label>
              <input
                type="text"
                name="author"
                placeholder="Author name"
                value={formData.author}
                onChange={handleChange}
                className="w-full border p-2 rounded mt-1"
                required
              />
            </Grid>

            <Grid item xs={12}>
              <label className="text-sm font-medium">Publish Date</label>
              <input
                type="date"
                name="dateOfPublish"
                value={formData.dateOfPublish}
                onChange={handleChange}
                className="w-full border p-2 rounded mt-1"
              />
            </Grid>

            {/* SEO Fields */}
            <Grid item xs={12}>
              <div className="border-t border-gray-200 my-2 pt-2">
                <Typography variant="subtitle1" className="font-semibold text-blue-600">
                  SEO Settings
                </Typography>
              </div>
            </Grid>

            <Grid item xs={12}>
              <label className="text-sm font-medium">Meta Title</label>
              <input
                type="text"
                name="metaTitle"
                placeholder="Meta title for SEO"
                value={formData.metaTitle}
                onChange={handleChange}
                className="w-full border p-2 rounded mt-1 text-sm"
              />
              <p className="text-xs text-gray-500 mt-1">Recommended: 50-60 characters</p>
            </Grid>

            <Grid item xs={12}>
              <label className="text-sm font-medium">Meta Description</label>
              <textarea
                name="metaDescription"
                placeholder="Brief description for search results"
                value={formData.metaDescription}
                onChange={handleChange}
                rows="2"
                className="w-full border p-2 rounded mt-1 text-sm"
              />
              <p className="text-xs text-gray-500 mt-1">Recommended: 150-160 characters</p>
            </Grid>

            <Grid item xs={12}>
              <label className="text-sm font-medium">Keywords</label>
              <input
                type="text"
                name="keywords"
                placeholder="comma separated keywords"
                value={formData.keywords}
                onChange={handleChange}
                className="w-full border p-2 rounded mt-1 text-sm"
              />
            </Grid>

            <Grid item xs={12}>
              <label className="text-sm font-medium">Canonical URL</label>
              <input
                type="url"
                name="canonical"
                placeholder="https://www.bbsrservices.co.in/blog/your-blog"
                value={formData.canonical}
                onChange={handleChange}
                className="w-full border p-2 rounded mt-1 text-sm"
              />
            </Grid>

            <Grid item xs={12}>
              <label className="text-sm font-medium">Description</label>
              <ReactQuill
                theme="snow"
                value={formData.description}
                onChange={handleQuillChange}
                modules={{
                  toolbar: [
                    [{ header: [1, 2, 3, false] }],
                    ['bold', 'italic', 'underline', 'strike'],
                    [{ color: [] }, { background: [] }],
                    [{ align: [] }],
                    ['blockquote', 'code-block'],
                    ['link', 'image'],
                    ['clean'],
                  ],
                }}
                formats={[
                  'header', 'bold', 'italic', 'underline', 'strike',
                  'color', 'background', 'align', 'blockquote',
                  'code-block', 'link', 'image',
                ]}
                className="bg-white mt-1"
              />
            </Grid>

            <Grid item xs={12}>
              <div className="mb-1 text-sm font-medium text-gray-700">
                Choose a Blog Image (600×500 size)
              </div>
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                required
                className="mt-1"
              />
              {imagePreview && (
                <div className="mt-3">
                  <p className="text-xs text-gray-500 mb-1">Preview:</p>
                  <img
                    src={imagePreview}
                    alt="Preview"
                    className="w-full max-h-48 object-cover rounded-lg border border-gray-200 shadow-sm"
                  />
                </div>
              )}
            </Grid>

            <Grid item xs={12}>
              <button
                type="submit"
                className="w-full bg-gradient-to-r from-[#FF3131] to-[#ff9301] text-white py-2 rounded-md"
                disabled={isLoading}
              >
                Add Blog
              </button>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Modal>
  );
};

export default AddBlogModal;